<template>
  <h1>Earthquakes App</h1>
</template>

<script>
export default {
  name: 'HeaderView',
};
</script>

<style scoped>
h1 {
  text-align: center;
}
</style>
